import React, { ComponentProps } from 'react';

import { Tabs } from '@zapier/design-system';

type Props = {
  currentUrl?: string;
  items: ComponentProps<typeof Tabs>['items'];
};

/*
 * This is a hacky resolution wrapping the Tabs component of
 * @zapier/design-system to meet our requirements. We want each tab to be a rich
 * link which trigges client-side routing while clicking.
 */
function LinkTabs(props: Props) {
  const { currentUrl, items } = props;

  const itemSelected = items.find(item => currentUrl?.startsWith(item.href));
  const selectedItemHref = itemSelected?.href ?? '';

  return (
    <Tabs
      items={items}
      onChooseItem={(_item, event) => event.preventDefault()}
      selectedItemHref={selectedItemHref}
    />
  );
}

export default LinkTabs;
